import React from "react";
import {
  Show,
  TabbedShowLayout,
  Tab,
  TopToolbar,
  ShowProps,
} from "react-admin";
import { Grid } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import Summary from "./Summary";
import Level from "./Level";
import DistanceArea from "./DistanceArea";
import Pricing from "./Pricing";
import TitleBreadcrumb from "components/TitleBreadcrumb";
import CustomFormLabel from "components/CustomFormLabel";
import AcademicYear from "./AcademicYear";
import BusSchedule from "./BusSchedule";
import InactivateSchoolButton from "./components/InactivateSchoolButton";
import ActivateSchoolButton from "./components/ActivateSchoolButton";

const SchoolShowAction = (props: any) => {
  const { data } = props;
  return (
    <TopToolbar>
      {data && (
        <>
          {" "}
          {data.status === "active" ? (
            <InactivateSchoolButton schoolId={data.id} />
          ) : (
            <ActivateSchoolButton schoolId={data.id} />
          )}{" "}
        </>
      )}
    </TopToolbar>
  );
};

const SchoolShow = (props: ShowProps) => {
  const { id } = props;

  const breadcrumb = [
    { link: "/schools", title: "Schools" },
    { link: `/schools/${id}`, title: id },
  ];

  return (
    <>
      <TitleBreadcrumb paths={breadcrumb} />
      <CustomFormLabel property={props} />
      <Show {...props} actions={<SchoolShowAction />}>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Summary">
                <Summary {...props} />
              </Tab>
              <Tab label="Level">
                <Level {...props} />
              </Tab>
              <Tab label="Bus Schedule">
                <BusSchedule {...props} />
              </Tab>
              <Tab label="Area To Distance">
                <DistanceArea {...props} />
              </Tab>
              <Tab label="Academic Year">
                <AcademicYear {...props} />
              </Tab>
              <Tab label="Pricing">
                <Pricing {...props} />
              </Tab>
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </Show>
    </>
  );
};

export default SchoolShow;
